export enum IWorkingSessionsAnalyticsActivityEnum {
  SessionId = 'WorkingSessionsAnalyticsActivity.session_id',
  LocalSessionStart = 'WorkingSessionsAnalyticsActivity.local_session_start',
  LocalSessionStartDate = 'WorkingSessionsAnalyticsActivity.local_session_start_date',
  LocalSessionEnd = 'WorkingSessionsAnalyticsActivity.local_session_end',
  FocusPercentage = 'WorkingSessionsAnalyticsActivity.focusPercentage',
  DigitalIntensity = 'WorkingSessionsAnalyticsActivity.digitalIntensity',
  SessionCallDuration = 'WorkingSessionsAnalyticsActivity.session_call_duration',
  SessionCallCount = 'WorkingSessionsAnalyticsActivity.session_call_count',
  TotalActivityDuration = 'WorkingSessionsAnalyticsActivity.totalActivityDuration',
  TotalFocusDuration = 'WorkingSessionsAnalyticsActivity.totalFocusDuration',
  TotalSessionCallDuration = 'WorkingSessionsAnalyticsActivity.totalSessionCallDuration',
  UserId = 'WorkingSessionsAnalyticsActivity.userid',
  CumulativeDailyAverageScreentime = 'WorkingSessionsAnalyticsActivity.cumulativeDailyAverageScreentime',
  CumulativeDailyAverageWorkingHours = 'WorkingSessionsAnalyticsActivity.cumulativeDailyAverageWorkingHours',
  CumulativeWeeklyAverageScreentime = 'WorkingSessionsAnalyticsActivity.cumulativeDailyAverageScreentime',
  CumulativeWeeklyAverageWorkingHours = 'WorkingSessionsAnalyticsActivity.cumulativeDailyAverageWorkingHours',
  WeekCount = 'WorkingSessionsAnalyticsActivity.weekCount',
  DayCount = 'WorkingSessionsAnalyticsActivity.dayCount',
  UserCount = 'WorkingSessionsAnalyticsActivity.userCount',
  CallWeekCount = 'WorkingSessionsAnalyticsActivity.callWeekCount',
  CallDayCount = 'WorkingSessionsAnalyticsActivity.callDayCount',
  WeekDayIndex = 'WorkingSessionsAnalyticsActivity.weekday_index',
  TotalDuration = 'WorkingSessionsAnalyticsActivity.totalDuration',
  ContextSwitches = 'WorkingSessionsAnalyticsActivity.context_switches',
  FocusScore = 'WorkingSessionsAnalyticsActivity.focus_score_v2',
  SessionDuration = 'WorkingSessionsAnalyticsActivity.session_duration',
  MeetingFocusScore = 'WorkingSessionsAnalyticsActivity.meeting_focus_score',
  LocalSessionStartWeek = 'WorkingSessionsAnalyticsActivity.local_session_start_week',
  SessionFocusDuration = 'WorkingSessionsAnalyticsActivity.session_focus_duration',
  SessionActivityDuration = 'WorkingSessionsAnalyticsActivity.session_activity_duration',
  ActivityCount = 'WorkingSessionsAnalyticsActivity.activity_count',
  UpdatedAt = 'WorkingSessionsAnalyticsActivity.updatedAt',
}
